/**
 * alp-lightbox.js — Alpine replacement for the vanilla Gallery.openLightbox (gallery.js).
 *
 * Design:
 *   - One Alpine.store('lightbox') is the single source of truth for the
 *     fullscreen overlay: which images, the start index, an optional title, and
 *     whether it's open.
 *   - Any gallery item opens it with $store.lightbox.show(images, index).
 *   - The overlay markup lives in snippets/alp-lightbox.liquid (rendered once,
 *     teleported to <body>) and binds to this store. Navigation/scroll/keyboard
 *     behavior is local to that snippet's x-data — the store only holds data.
 *
 * Loaded before Alpine (like alp-wishlist.js) so its alpine:init listener
 * registers the store before Alpine.start() fires.
 */
(function () {
  'use strict';
  if (window.__alpLightboxLoaded) return;
  window.__alpLightboxLoaded = true;

  document.addEventListener('alpine:init', function () {
    Alpine.store('lightbox', {
      open: false,
      images: [],
      startIndex: 0,
      title: '',

      // images: [{ src, srcset?, alt? }]. Opens the overlay at startIndex.
      show: function (images, startIndex, opts) {
        opts = opts || {};
        this.images = Array.isArray(images) ? images : [];
        if (!this.images.length) return;
        this.startIndex = startIndex || 0;
        this.title = opts.title || '';
        this.open = true;
      },

      close: function () {
        this.open = false;
      },
    });
  });
})();
